import { Component, Input } from '@angular/core';

@Component({
    selector: 'ssf-help-bubble',
    template: require('./help-bubble.component.html')
})
export class HelpBubbleComponent {
    /**
     * Text to be shown above the element on hover.
     */
    @Input() text;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/help-bubble/help-bubble.component.ts